import { render, staticRenderFns } from "./TimesBlock.vue?vue&type=template&id=628512ba&scoped=true&"
import script from "./TimesBlock.vue?vue&type=script&lang=js&"
export * from "./TimesBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628512ba",
  null
  
)

export default component.exports